<template>
  <div class="p-menu">
    <menu-co></menu-co>

    <div class="page-menu-wrapper">
      <div class="menu-new-wrapper">
        <h2>{{ $lang.menu.menu_titel }}</h2>
        <p>{{ $lang.menu.ingress }}</p>
      </div>

      <div class="side-menu">
        <div class="sidemenu-box">

          <div class="pure-g button-wrapper set-lg">

            <div class="pure-u-1-1 pure-u-md-1-2">
              <div class="pure-g">
                <menu-option v-for="(option, index) in options1" :key="index"
                             :values="option"
                             :isbutton="false"
                ></menu-option>
              </div>
            </div>

            <div class="pure-u-1-1 pure-u-md-1-2">
              <div class="pure-g">
                <menu-option v-for="(option, index) in options2" :key="index"
                             :values="option"
                             :isbutton="false"
                ></menu-option>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="menu-new-wrapper">
        <div class="btn green" v-touch:tap="moveToCurrentCategory">{{ $lang.menu.btn_move_on }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dataOption from '../../../assets/data/staticdata.json'
import Menu from '../../../components/menu/'
import Options from '../../../components/menu-options/'

import Context from '../../../assets/data/context.json'

export default {
  name: 'all-progress',
  data () {
    return {
      showMenu: true,
      menuOpened: false,
      menuBuild: false,
      context: '',
      options1: {},
      options2: {},
      halfCasesLength: 0,
      halfCount: 0,
      dataOptions: dataOption,
      dataContext: Context
    }
  },
  beforeMount () {
    this.context = this.store.getItemOrDefault(this.dataContext.current_context, 'transport')
    this.buildMenu()
  },
  methods: {
    buildMenu (override) {
      if (!this.menuBuild && (override === undefined || !override)) {
        let count = 1
        let progress = this.store.getItemByCategory(this.dataContext.current_progress, this.context)
        let progressCopy = this.util.copyArrayByField(progress, 'name')
        this.halfCasesLength = parseInt(this.dataOptions.caselists[this.context].length / 2)
        this.halfCount = 0
        this.options1 = {}
        this.options2 = {}

        for (let i = 0; i < this.$lang.menu.options.length; i++) {
          let option = this.$lang.menu.options[i]
          let objectKey = Object.keys(option)
          if (option.hasOwnProperty(objectKey)) {
            // Checks so this user has this menu option
            let shouldHaveOption = this.util.arrayContainsValue(
              option[objectKey].caseref,
              this.dataOptions.caselists[this.context]
            )
            if (shouldHaveOption) {
              if (this.halfCount <= this.halfCasesLength) {
                this.options1['opt' + count] = option[objectKey]
                this.options1['opt' + count].checked = this.util.arrayContainsValue(option[objectKey].caseref, progressCopy)
              } else {
                this.options2['opt' + count] = option[objectKey]
                this.options2['opt' + count].checked = this.util.arrayContainsValue(option[objectKey].caseref, progressCopy)
              }
              this.halfCount++
            }
            count++
          }
        }
        this.menuBuild = true
      }
    },
    moveToCurrentCategory () {
      let catCases = this.dataOptions.caselists[this.context]
      let progress = this.store.getItem(this.dataContext.current_progress)[this.context]
      let moveTo = this.util.getFirstQuestionForCategoryNotAnswered(catCases, progress)
      if (!moveTo) {
        this.$router.push({ path: `/case-lobby/case1` })
      } else {
        this.$router.push({ path: `/case-lobby/${moveTo}` })
      }
    }
  },
  components: {
    'menu-co': Menu,
    'menu-option': Options
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/case-progress/index.vue